import React, { useState } from "react";

import { useDocumentTypes } from "features/documents/hooks/useDocumentTypes";
import { DeleteDocumentTypeModal } from "features/documentTypes/modals/DeleteDocumentTypeModal";
import { DocumentTypeFormModal } from "features/documentTypes/modals/DocumentTypeFormModal";
import { DocumentTypesTable } from "features/documentTypes/tables/DocumentTypesTable/DocumentTypesTable";

const DocumentTypesPage = () => {
  const { data: documentTypes = [], isLoading } = useDocumentTypes();

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState(null);

  const handleAdd = () => {
    setSelectedDocType(null);
    setIsAddOpen(true);
  };

  const handleEdit = (docType) => {
    setSelectedDocType(docType);
    setIsEditOpen(true);
  };

  const handleDelete = (docType) => {
    setSelectedDocType(docType);
    setIsDeleteOpen(true);
  };

  return (
    <div>
      <DocumentTypesTable
        documentTypes={documentTypes}
        isLoading={isLoading}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <DocumentTypeFormModal
        isOpen={isAddOpen}
        onClose={() => setIsAddOpen(false)}
      />

      <DocumentTypeFormModal
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        documentType={selectedDocType}
      />

      <DeleteDocumentTypeModal
        isOpen={isDeleteOpen}
        onClose={() => setIsDeleteOpen(false)}
        documentType={selectedDocType}
      />
    </div>
  );
};

export { DocumentTypesPage };
